import { render, staticRenderFns } from "./DeliveryTransport.vue?vue&type=template&id=2872afb2&"
import script from "./DeliveryTransport.vue?vue&type=script&lang=js&"
export * from "./DeliveryTransport.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTransport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports